import React from "react";

import nissanka from "./img/nissanka.jpg";
import hiruni from "./img/hiruni.jpg";
import iresha from "./img/iresha.jpg";
import PiyumiSandunika from "./img/PiyumiSandunika.jpg";
import RidmaSirimanna from "./img/RidmaSirimanna.jpeg";
import Shafana from "./img/Shafana.jpeg";
import AnjaleeGunathunga from "./img/AnjaleeGunathunga.jpeg";
import SenaliLavanyaPeiris from "./img/SenaliLavanyaPeiris.jpg";
import IsuriKarunaratne from "./img/IsuriKarunaratne.jpg";
import PavithraBamunusinghe from "./img/PavithraBamunusinghe.jpg";
import Pulmini from "./img/Pulmini.jpg";
import sahan from "./img/sahan.png";

export default function CommetteMember() {
  return (
    <div className="CommetteMemberDiv">
      <div className="row AboutUsComponent">
        <div className="col-md-12 text-center">
          <h3> EXECUTIVE BOARD 2020/2021</h3>
          <hr className="HrBreaker" />
        </div>
        {/* Column One Start */}
        <div
          className="col-lg-3 col-md-6 AboutUsComponent"
          data-aos="zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="1000"
        >
          <div className="text-center">
            <img
              src={PiyumiSandunika}
              class="card-img-top MemberImage"
              alt="memeber1"
            />
          </div>

          <div class="card-body text-center">
            <p class="card-text">Piyumi Sandunika</p>

            <p class="card-text ">
              <span className="memberrole">PRESIDENT</span>
            </p>
          </div>
        </div>
        {/* Column One End */}
        {/* Column One Start */}
        <div
          className="col-lg-3 col-md-6 AboutUsComponent"
          data-aos="zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="1000"
        >
          <div className="text-center">
            <img
              src={RidmaSirimanna}
              class="card-img-top MemberImage"
              alt="memeber1"
            />
          </div>

          <div class="card-body text-center">
            <p class="card-text">Ridma Sirimanna</p>

            <p class="card-text ">
              <span className="memberrole">VICE PRESIDENT</span>
            </p>
          </div>
        </div>
        {/* Column One End */}
        {/* Column One Start */}
        <div
          className="col-lg-3 col-md-6 AboutUsComponent"
          data-aos="zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="1000"
        >
          <div className="text-center">
            <img
              src={Shafana}
              class="card-img-top MemberImage"
              alt="memeber1"
            />
          </div>

          <div class="card-body text-center">
            <p class="card-text">Shafana Shafeek</p>

            <p class="card-text ">
              <span className="memberrole">SECRETARY</span>
            </p>
          </div>
        </div>
        {/* Column One End */}
        {/* Column One Start */}
        <div
          className="col-lg-3 col-md-6 AboutUsComponent"
          data-aos="zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="1000"
        >
          <div className="text-center">
            <img src={hiruni} class="card-img-top MemberImage" alt="memeber1" />
          </div>

          <div class="card-body text-center">
            <p class="card-text">Dr.Hiruni Harischandra</p>

            <p class="card-text ">
              <span className="memberrole">SENIOR TREASURER </span>
            </p>
          </div>
        </div>
        {/* Column One End */}
        {/* Column One Start */}
        <div
          className="col-lg-3 col-md-6 AboutUsComponent"
          data-aos="zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="1000"
        >
          <div className="text-center">
            <img
              src={AnjaleeGunathunga}
              class="card-img-top MemberImage"
              alt="memeber1"
            />
          </div>

          <div class="card-body text-center">
            <p class="card-text">Anjalee Gunathunga</p>

            <p class="card-text ">
              <span className="memberrole"> JUNIOR TREASURER </span>
            </p>
          </div>
        </div>
        {/* Column One End */}
        {/* Column One Start */}
        <div
          className="col-lg-3 col-md-6 AboutUsComponent"
          data-aos="zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="1000"
        >
          <div className="text-center">
            <img
              src={SenaliLavanyaPeiris}
              class="card-img-top MemberImage"
              alt="memeber1"
            />
          </div>

          <div class="card-body text-center">
            <p class="card-text">Senali Lavanya</p>

            <p class="card-text ">
              <span className="memberrole">ASSISTANT SECRETARY </span>
            </p>
          </div>
        </div>
        {/* Column One End */}
        {/* Column One Start */}
        <div
          className="col-lg-3 col-md-6 AboutUsComponent"
          data-aos="zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="1000"
        >
          <div className="text-center">
            <img
              src={IsuriKarunaratne}
              class="card-img-top MemberImage"
              alt="memeber1"
            />
          </div>

          <div class="card-body text-center">
            <p class="card-text">Isuri Karunarathna</p>
            <p class="card-text ">
              <span className="memberrole">COMMITTEE MEMBER</span>
            </p>
          </div>
        </div>
        {/* Column One End */}
        {/* Column One Start */}
        <div
          className="col-lg-3 col-md-6 AboutUsComponent"
          data-aos="zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="1000"
        >
          <div className="text-center">
            <img
              src={PavithraBamunusinghe}
              class="card-img-top MemberImage"
              alt="memeber1"
            />
          </div>

          <div class="card-body text-center">
            <p class="card-text">Pavithra Bamunusinghe</p>
            <p class="card-text ">
              <span className="memberrole">COMMITTEE MEMBER</span>
            </p>
          </div>
        </div>
        {/* Column One End */}
        {/* Column One Start */}
        <div
          className="col-lg-3 col-md-6 AboutUsComponent"
          data-aos="zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="1000"
        >
          <div className="text-center">
            <img
              src={Pulmini}
              class="card-img-top MemberImage"
              alt="memeber1"
            />
          </div>

          <div class="card-body text-center">
            <p class="card-text"> Pulmini Alwis</p>
            <p class="card-text ">
              <span className="memberrole">COMMITTEE MEMBER</span>
            </p>
          </div>
        </div>
        {/* Column One End */}
        {/* Column One Start */}
        <div
          className="col-lg-3 col-md-6 AboutUsComponent"
          data-aos="zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="1000"
        >
          <div className="text-center">
            <img src={sahan} class="card-img-top MemberImage" alt="memeber1" />
          </div>

          <div class="card-body text-center">
            <p class="card-text">Sahan Madusanka</p>
            <p class="card-text ">
              <span className="memberrole">COMMITTEE MEMBER</span>
            </p>
          </div>
        </div>
        {/* Column One End */}
        {/* Column One Start */}
        <div
          className="col-lg-3 col-md-6 AboutUsComponent"
          data-aos="zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="1000"
        >
          <div className="text-center">
            <img
              src={nissanka}
              class="card-img-top MemberImage"
              alt="memeber1"
            />
          </div>

          <div class="card-body text-center">
            <p class="card-text"> Prof. Nissanka de Silva</p>
            <p class="card-text ">
              <span className="memberrole">ADVISOR </span>
            </p>
          </div>
        </div>
        {/* Column One End */}
      </div>
    </div>
  );
}
